// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:480px){.input-group-text[data-v-0d07c5ee]{font-size:14px;display:inline-block;max-width:70px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}}", ""]);
// Exports
module.exports = exports;
